import axiosClient from "../api/axiosClient";
import { CheckNullParams } from "../utils/CheckNullParams";
const promotionApi = {
  getPromotions: (params) => {
    const url = "promotion";
    const payload = CheckNullParams(params);
    return axiosClient.get(url, {
      params: payload,
    });
  },

  getPromotion: (id) => {
    const url = "promotion";
    return axiosClient.get(url + "/" + id);
  },

  createPromotion: (params) => {
    const url = "promotion";
    const payload = CheckNullParams(params);
    return axiosClient.post(url, payload);
  },
  
  updatePromotion: (id, payload) => {
    const url = "promotion/";
    return axiosClient.patch(url + id, payload);
  },

  deletePromotion: (params) => {
    const url = "promotion";
    console.log("params", params);
    return axiosClient.delete(url, { params });
  },
};

export default promotionApi;
